<template>
    <div>
        <p class="text-center mb-0">{{unidadeSelecionada.cnes}} - {{unidadeSelecionada.nome}}</p>
        <p class="text-center mb-0"><strong>Enfermaria:</strong> {{dados.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{dados.leitoCodigo}}</p>
        <p class="text-center"><strong>{{dados.leitoNomeEnfermaria}}</strong></p>

        <div class="row">
            <div class="form-group col-sm-12">
                <label for="unidade">CID</label>
                <multiselect
                    :options="listaCid"
                    track-by="cid"
                    label="cid"
                    :searchable="true"
                    placeholder="Pesquise e selecione"
                    selectLabel="+"
                    deselectLabel="-" 
                    selectedLabel="selecionado"
                    v-model="cid10"
                    >

                    <span slot="noResult">Nenhum resultado encontrado.</span>
                </multiselect>
                <!-- <small v-if="cid == null" class="text-danger">preenchimento obrigatório</small> -->
            </div>
        </div>

        <div class="row">
            <div class="form-group col-sm-12">
                <label>Hipótese Diagnóstica</label>
                <textarea class="form-control" rows="4" v-model="hipoteseDiagnostico"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-sm-6">
                <label>Data Início dos Sintomas</label>
                <input type="date" class="form-control" v-model="dataInicioSintomas">
            </div>

            <div class="form-group col-sm-6">
                <label>O2</label>
                <select class="form-control" v-model="oxigenacao">
                    <option value="" disabled>Selecione</option>
                    <option v-for="(item, index) in selects.oxigenacao" :key="index" :value="item.id">{{item.nome}}</option>
                </select>
            </div>
        </div>
        <div class="row">
             <div class="form-group col-sm-6">
                <label>Data da Coleta</label>
                <input type="date" class="form-control" v-model="dataColeta">
            </div>
        </div>

        <div class="row">
             <div class="form-group col-sm-6">
                <label>Tipo de Exame</label>
                <select class="form-control" v-model="tipoExame">
                    <option value="" disabled>Selecione</option>
                    <option v-for="(item, index) in selects.tipoExame" :key="index" :value="item.id">{{item.nome}}</option>
                </select>
                <small v-if="tipoExame == ''" class="text-danger">preenchimento obrigatório</small>
            </div>
             <div class="form-group col-sm-6">
                <label>Resultado do Exame</label>
                <select class="form-control" v-model="resultadoExame">
                    <option value="" disabled>Selecione</option>
                    <option v-for="(item, index) in selects.resultadoExame" :key="index" :value="item.id">{{item.nome}}</option>
                </select>
                <small v-if="resultadoExame == ''" class="text-danger">preenchimento obrigatório</small>
            </div>
        </div>

        <div class="row d-flex align-items-end">
             <div class="form-group col-sm-6">
                <label>Situação</label>
                <select class="form-control" v-model="situacao">
                    <option value="" disabled>Selecione</option>
                    <option v-for="(item, index) in selects.situacao" :key="index" :value="item.id">{{item.nome}}</option>
                </select>
            </div>
             <div class="form-group col-sm-6">
                <label>Classificação de Risco no Momento</label>
                <select class="form-control" v-model="classificacaoRiscoMomento">
                    <option value="" disabled>Selecione</option>
                    <option v-for="(item, index) in selects.classificacaoRiscoMomento" :key="index" :value="item.id">{{item.nome}}</option>
                </select>
                <small v-if="classificacaoRiscoMomento == ''" class="text-danger">preenchimento obrigatório</small>
            </div>
        </div>

        <div class="row">
             <div class="form-group col-sm-6">
                <label>Prioridade Regulação</label>
                <select class="form-control" v-model="prioridadeRegulacao">
                    <option value="" disabled>Selecione</option>
                    <option v-for="(item, index) in selects.prioridadeRegulacao" :key="index" :value="item.id">{{item.nome}}</option>
                </select>
                 <small v-if="prioridadeRegulacao == ''" class="text-danger">preenchimento obrigatório</small>
            </div>
        </div>

        <button type="button" class="btn btn-primary"  @click="validaSessao('registrar')">Registrar</button>
    </div>
</template>

<script>
    import { validaSessao } from '../../../shared/mixins/validaSessao'
    export default {
        props: {
            dados: Object
        },
        mixins: [
            validaSessao
        ],
        mounted () {
            this.verificaAcompanhamento();
        },
        data() {
            return {
                cid10: null,
                hipoteseDiagnostico: '',
                dataInicioSintomas: '',
                oxigenacao: '',
                dataColeta: '',
                tipoExame: '',
                resultadoExame: '',
                situacao: '',
                classificacaoRiscoMomento: '',
                prioridadeRegulacao: '',
            }
        },
        watch: {
            hipoteseDiagnostico (v) {
                this.hipoteseDiagnostico = v.toUpperCase()
            }
        },
        computed: {
            unidadeSelecionada () {
                return this.$store.getters['filtro/getUnidadeSelecionada']
            },
            listaCid () {
                return this.$store.getters['consultas/getListaCid']
            },
            selects () {
                return this.$store.getters['leitos/getOpcoesSelect']
            },
        },
        methods: {
            async verificaAcompanhamento () {
                try {
                    let resp = await this.$store.dispatch('leitos/listarAcompanhamento', this.dados.internacaoId)
                    if (resp.data.status == true) {
                        this.cid10 = this.listaCid.filter(i => i.codigoCid == resp.data.dados.cid10)[0]
                        this.dataColeta = resp.data.dados.dataColeta
                        this.dataInicioSintomas = resp.data.dados.dataInicioSintomas
                        this.hipoteseDiagnostico = resp.data.dados.hipoteseDiagnostico
                        this.classificacaoRiscoMomento = resp.data.dados.idClassificacaoRiscoMomento
                        this.oxigenacao = resp.data.dados.idOxigenacao
                        this.prioridadeRegulacao = resp.data.dados.idPrioridadeRegulacao
                        this.resultadoExame = resp.data.dados.idResultadoExame
                        this.situacao = resp.data.dados.idSituacao
                        this.tipoExame = resp.data.dados.idTipoExame
                    }
                }
                catch (e) {
                    console.error(e)
                }
            },
            registrar () {
                if (this.tipoExame == '' || this.resultadoExame == '' || this.classificacaoRiscoMomento == '' || this.prioridadeRegulacao == '' ) return

                let dados = {
                    cid10: this.cid10 ? this.cid10.codigoCid : '',
                    hipoteseDiagnostico: this.hipoteseDiagnostico.toUpperCase(),		
                    dataInicioSintomas: this.dataInicioSintomas,		
                    oxigenacao: this.oxigenacao,						
                    dataColeta: this.dataColeta,				
                    tipoExame: this.tipoExame,
                    resultadoExame: this.resultadoExame,
                    situacao: this.situacao,							
                    classificacaoRiscoMomento: this.classificacaoRiscoMomento,				
                    prioridadeRegulacao: this.prioridadeRegulacao,
                    idInternacao: this.dados.internacaoId
                }

                 this.$emit('registro', dados)
            }
        },
    }
</script>

<style>

</style>